import ClassificationStudentImage from './images/classification-student.png';
import ClassificationInstructorImage from './images/classification-instructor.jpg';
import NormalImage from './images/normal.png';
import ThePrinciplesImage from './images/the-principles.png';
import BalancedEquationImage from './images/balanced-equation.png';

import './styles.css';

const transitionConfig = {
  'Account Classification': {
    instructor: {
      image: ClassificationInstructorImage,
      imageClass: 'transition-image-instructor',
      getTitle: () => 'Welcome To The Account Classification Game!',
      getSubtitle: (user) => `Hi${user?.first_name ? ' ' + user.first_name : ''}!`,
    },
    student: {
      image: ClassificationStudentImage,
      imageClass: 'transition-image-student',
      getTitle: () => 'Account Classification Game',
      getSubtitle: () => '',
    },
  },
  'Normal Balance': {
    default: {
      image: NormalImage,
      imageClass: 'transition-image-student',
      getTitle: () => 'Welcome To The Normal Balance Game!',
      getSubtitle: (user) => `Hi${user?.alias_name ? ' ' + user.alias_name : ''}!`,
    },
  },
  'The Principles': {
    default: {
      image: ThePrinciplesImage,
      imageClass: '',
      getTitle: () => 'The Principles',
      getSubtitle: () => '',
    },
  },
  'Balanced Equation': {
    default: {
      image: BalancedEquationImage,
      imageClass: '',
      getTitle: () => 'The Balanced Equation',
      getSubtitle: () => '',
      textUnderImage: 'As in life, so too in accounting: balance is key',
    },
  },
};

function getConfig(gameType, isInstructor, isStudent) {
  for (const [key, config] of Object.entries(transitionConfig)) {
    if (gameType?.includes(key)) {
      if (config.instructor && isInstructor) return config.instructor;
      if (config.student && isStudent) return config.student;
      return config.default || config.student || config.instructor;
    }
  }
  return null;
}

export default function TransitionDefault({
  gameType, 
  isInstructor,
  isStudent,
  user
}) {
  const config = getConfig(gameType, isInstructor, isStudent);

  if (!config) return null;

  const title = config.getTitle(user);
  const subtitle = config.getSubtitle?.(user) || '';

  return (
    <div className="page-content transition-page-default-content">
      {subtitle && <h2 className="page-subtitle">{subtitle}</h2>}
      <h1 className="page-title">{title}</h1>
      <div className="loader"/>
      {config.image && (
        <img 
          src={config.image} 
          alt='The game is loading' 
          className={`transition-image ${config.imageClass}`} 
        />
      )}
      {config.textUnderImage && (
        <p className="transition-under-the-image">{config.textUnderImage}</p>
      )}
    </div>
  );
}
